import { jsx as _jsx } from "react/jsx-runtime";
import Link from '../../Link/Link';
const CategoryLinkGalleryTextAndIcon = ({ categories, wrapperClassName, itemClassName, linkClassName, sendCategoryCarouselClickAnalytics, }) => {
    return (_jsx("div", { className: wrapperClassName, children: categories.map((category, index) => (_jsx("div", { className: itemClassName, children: _jsx(Link, { label: category.label, url: category.url, className: linkClassName, triggerLinkAnalytics: sendCategoryCarouselClickAnalytics
                    ? (linkText) => sendCategoryCarouselClickAnalytics(linkText || category.label || category.title || '')
                    : undefined }) }, `text-icon-item-${category.label}-${index}`))) }));
};
export default CategoryLinkGalleryTextAndIcon;
